import { Badge } from '@repo/ui/src/components/ui/badge';
import { formatDate, isPeriodEndNear } from '../lib/adminFormat';

interface PeriodEndCellProps {
  currentPeriodEnd: string | null;
}

/** Renders a plan's `currentPeriodEnd` as a tabular date, flagged with the
 *  ochre "attention" tint when it's near or past — the one deliberate use of
 *  the accent in admin (money-that-needs-attention, not the destructive
 *  suspended state). Shared between OrgsPage's table and OrgDetailPage. */
export function PeriodEndCell({ currentPeriodEnd }: PeriodEndCellProps) {
  const label = formatDate(currentPeriodEnd);
  if (currentPeriodEnd && isPeriodEndNear(currentPeriodEnd)) {
    return (
      <Badge variant="warning" className="tabular-nums font-normal">
        {label}
      </Badge>
    );
  }
  return <span className="tabular-nums text-surface-700">{label}</span>;
}
